import { APP_LINKS, APP_SUB_MENUS, NAVBAR_LINKS } from '@utils/variables';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { ISubmenu } from 'src/components/navbar/Sublinks/Sublinks.type';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import { ESubmenuType } from 'src/styles/theme/utils/enums';
import { IAppLink } from '../../types/global';
import { pathnameQueryAtom, subpageQueryParamAtom } from '../appRouter/appRouter.atoms';
import { EOriginQuest } from './appState.enum';
import { extractPageIdFromPathname } from './appState.functions';
import { ORIGIN_QUEST_KEY } from './appState.variables';

// the id of the page that is currently active
const currentPageIdAtom = atom<IAppLink['id'] | null>((get) => {
	const pathname = get(pathnameQueryAtom);

	if (!pathname) {
		return null;
	}

	return extractPageIdFromPathname(pathname);
});

// the subpage that is currently active
const currentSubpageAtom = atom<ISubmenu>((get) => {
	const currentPageId = get(currentPageIdAtom);
	const pathname = get(pathnameQueryAtom);
	const subpageQueryParam = get(subpageQueryParamAtom);
	const page = NAVBAR_LINKS.find((navlink) => navlink.id === currentPageId);
	const submenus = page?.submenus || [];

	if (pathname === APP_LINKS.singleQuest.href) {
		return APP_SUB_MENUS.devhub.quests;
	}

	if (subpageQueryParam) {
		const subpage = submenus.find((submenu) => submenu.id === subpageQueryParam);
		if (subpage) {
			return subpage;
		}
	}

	return (
		submenus[0] || {
			id: '',
			type: ESubmenuType.unset,
			label: '',
			icon: EIcon.unset
		}
	);
});

/*
	the origin of the quest (from quest, from campaign or quest log),
	allows redirection of the user to the right page when the he/she starts or navigates to a quest
*/
const originQuestAtom = atomWithStorage<EOriginQuest>(ORIGIN_QUEST_KEY, EOriginQuest.fromQuest);

export { currentPageIdAtom, currentSubpageAtom, originQuestAtom };
